import { FormControl, RadioGroup } from "@mui/material";
import { Control, Controller } from "react-hook-form";

type RadioGroupControllerProps = {
  control: Control;
  name: string;
  options: any[];
  renderOption: (option: any) => React.ReactNode;
  row?: boolean;
  disabled?: boolean;
  defaultValue: string;
};

const RadioGroupController = ({
  control,
  name,
  options,
  renderOption,
  row,
  disabled,
  defaultValue,
}: RadioGroupControllerProps) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => (
        <FormControl disabled={disabled}>
          <RadioGroup
            row={row}
            value={field.value}
            onChange={(e) => field.onChange(e.target.value)}
          >
            {options.map((option) => renderOption(option))}
          </RadioGroup>
        </FormControl>
      )}
    />
  );
};

export default RadioGroupController;
